import React from 'react'
import { Link } from 'react-router-dom';
import { HiOutlineArrowUpRight } from "react-icons/hi2";


const Footer = () => {
  return (
    <>
        <div className='footer-main-cover-wrapper'>
            <div className='footer-inner-cover'>
                <div className='row'>
                    <div className='col-lg-5'>
                        <div className='footer-contact'>
                            <div className='footer-header-title'>
                                <h5>Get the Latest Information From Us</h5>
                            </div>
                            <div className='footer-input-box-cover'>
                                <div className='footer-input-box'>
                                    <input type='text' placeholder='Enter Your Email'/>
                                    <button>
                                        <HiOutlineArrowUpRight/>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='col-lg-2'>
                        {/* <div className='footer-links'>
                            <h5>Quick links</h5>
                            <Link>
                                Home
                            </Link>
                            <Link>
                                About us
                            </Link>
                            <Link>
                                Projects
                            </Link>
                            <Link>
                                Contact us
                            </Link>
                            <Link>
                                Services
                            </Link>
                        </div> */}
                    </div>
                    <div className='col-lg-2'>
                        <div className='footer-links'>
                            <h5>Quick links</h5>
                            <Link>
                                Home
                            </Link>
                            <Link>
                                About us
                            </Link>
                            <Link>
                                Projects
                            </Link>
                            <Link>
                                Contact us
                            </Link>
                            <Link>
                                Services
                            </Link>
                        </div>
                    </div>
                    <div className='col-lg-2'>
                        <div className='footer-links'>
                            <h5>Solutions</h5>
                            <Link>
                                Web Design
                            </Link>
                            <Link>
                                Web Developement
                            </Link>
                            <Link>
                                Software Developement
                            </Link>
                            <Link>
                                Poster Design
                            </Link>
                            <Link>
                                Services
                            </Link>
                        </div>
                    </div>

                </div>
                
            </div>
        </div>
    </>
  )
}

export default Footer